import { GeoJSON } from 'ol/format';
import { Fill, Stroke, Style } from 'ol/style';

/**
 * Istanza GeoJSON condivisa con proiezione EPSG:3857.
 */
export const geoJSONEpsg3857 = new GeoJSON({
  featureProjection: 'EPSG:3857',
});

/**
 * Stile sintetico per i layer creati dalle migrazioni widget
 * (intersezione e competenza da widget-level a layer-level).
 */
export const SYNTHETIC_LAYER_STYLE = {
  fillColor: '#3388ff',
  strokeColor: '#3388ff',
  strokeWidth: 2,
  opacity: 0.5,
};

/**
 * Crea uno stile di evidenziazione per feature sulla mappa.
 */
export function createHighlightStyle(
  fillColor: string,
  strokeColor: string,
  strokeWidth = 2,
): Style {
  return new Style({
    fill: new Fill({ color: fillColor }),
    stroke: new Stroke({ color: strokeColor, width: strokeWidth }),
  });
}
